import React, { useState } from "react";
import ReactMarkdown from "react-markdown";

import logo from "./logo.svg";
import "./App.css";

const parties = [
    { id: "conservatives", name: "Conservative and Unionist Party" },
    { id: "labour", name: "Labour Party" },
    { id: "co-op", name: "Co-operative Party" },
    { id: "", name: "Scottish National Party" },
    { id: "", name: "Liberal Democrats" },
    { id: "", name: "Democratic Unionist Party" },
    { id: "", name: "Sinn Féin" },
    { id: "", name: "Plaid Cymru" },
    { id: "", name: "Social Democratic and Labour Party" },
    { id: "", name: "Alba Party" },
    { id: "", name: "Green Party of England and Wales" },
    { id: "", name: "Alliance Party of Northern Ireland" },
];

interface Party {
    id: string;
    name: string;
    vote: boolean | null;
}

function App() {
    const [ballotData, setBallotData] = useState<Party[]>(parties.map(({ id, name }) => ({ id, name, vote: null })));

    const markBallot = (name: string) => {
        const newBallot = ballotData.map((entry) => ({ id: entry.id, name: entry.name, vote: name === entry.name }));
        setBallotData(newBallot);
    };

    const votedFor = ballotData.find((entry) => entry.vote)?.id;

    const ballot = (
        <table>
            <tbody>
                {ballotData.map(({ name, vote }) => {
                    let marker: React.ReactNode = "";
                    if (vote === true) {
                        marker = <span>✗</span>;
                    }
                    return (
                        <tr key={name}>
                            <td>{name}</td>
                            <td className="check-cell">
                                <button onClick={() => markBallot(name)}>{marker}</button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );

    return (
        <div className="App">
            <h1>Cast your vote</h1>
            {ballot}
            <div className="App-description">
                <Explanation id={votedFor} />
            </div>
        </div>
    );
}

function Explanation({ id }: { id: string | undefined }) {
    switch (id) {
        case "conservatives":
            return <ReactMarkdown>{conservatives}</ReactMarkdown>;
        case "labour":
            return <ReactMarkdown>{labour}</ReactMarkdown>;
    }
    return null;
}

export default App;

const conservatives = `
# You voted for the Conservative and Unionist Party

Unfortunately, you live in Gorton in Greater Manchester which is a Labour safe seat. 

Your vote counts for nothing.

## But I don't live in Gorton

We don't actually know where you live but in 2010 it was judged that 59% of seats were safe seats so there is a good chance you're in a safe seat and even if you're not, think of all the people that are! 59% of people voting in the UK had individually practically no impact on the outcome of the election. 59%!

## What if I like the party that holds my safe seat?

It is great that you'll be represented by someone that you agree with but you could have even better representation if our elections cared about how many votes your candidate received. With our current system, all votes over the threshold needed to win a particular seat also have no impact on the outcome of the election. You get the same representation whether your candidate wins by a single vote or by 40,000 votes. In Gorton that meant that 81% of the votes didn't matter in the last election.

## Why is this the case?

This happens in the UK because of the way that we divide up and count the votes. We use a voting system called First Past the Post. There are plenty of much better systems. Loads of countries have opted to change from First Part the Post to other better voting systems. We refer to these better system as being in the category of 'proportional representation' because the proportion of MPs in parliament from each party better reflect the proportion of votes each party received across the country.
`;

const labour = `
# Labour Party

Unfortunately, you live in Staffordshire South which is a Conservative safe seat. 

Your vote counts for nothing.
`;
